import { render, staticRenderFns } from "./WiringForm.vue?vue&type=template&id=6b0424f7"
import script from "./WiringForm.vue?vue&type=script&lang=js"
export * from "./WiringForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports